import
{
    buildSettings,
    BuildSettings
}
    from 'src/app/settings';

const settings: BuildSettings = buildSettings;

export const faqListApp: any[] = [
    {
        q: `I am getting erratic temperature readings or heat alarms from the system`,
        a: `Check the physical setup of the camera following the instructions included in the ${settings.appName} app. 
    Pay special attention to the background. Check for uniformity in the background and that no foreign 
    heat sources are visible in the scanning area. If the problem persists, redo the calibration step.`
    },
    {
        q: `My ${settings.appName} App is unresponsive and looks “frozen” `,
        a: `Terminate the ${settings.appName} App and restart.`
    },
    {
        q: `My battery runs down quickly`,
        a: `The ${settings.appName} App may cause excessive battery to drain faster than usual and its recommended to connect
    the camera to a permanent power source (AC outlet or power bank) during scanning.`
    },
    {
        q: `I cannot find the Flex App icon on my phone`,
        a: `Your app icon should auto-install to the centre of your home screen. If you are unable to locate it try searching for the Flex App under Apps on your CAT phone.`
    },
    {
        q: `I have accidentally deleted my Flex App. How do I recover it?`,
        a: `You can download the Flex app from the Google Play Store (url link here), alternatively you can perform a factory reset on your device and the Flex application will automatically reinstall on your device.`
    },
    {
        q: `The calibration is completed, but the Flex App still displays “Start Calibration” message on the screen`,
        a: `Press the Scan button, located at the bottom of the screen between the Settings and Alerts buttons, to begin scanning.`
    },
    {
        q: `The app display “warming up” but it takes a long time`,
        a: `This is normal.  The warmup period is 10min to ensure that the sensor temperature is stable before calibration and scanning can begin`
    },
    {
        q: `The device display “The thermal sensor failed to initialize. Please restart”`,
        a: `The App is unable to start the FLIR thermal sensor and needs to restart. Terminate the Flex App and restart.`
    },
    {
        q: `Can I scan people wearing head gear such as hats, beanies, bandannas etc?`,
        a: `All head gear should be removed as it will negatively affect scanning performance, and consequently the accuracy of the scanning result.`
    },
    {
        q: `How do I Log Out of the Flex App?`,
        a: `End the scanning session by pressing the “Scan” button on the Flex App and then terminating/closing the App`
    },
    {
        q: `How do I see on which version of the Flex App is installed on my device?`,
        a: `The version of Flex App software is displayed under the Settings menu of the App.`
    },
    {
        q: `How do I show or hide the step by step setup instructions each time I start the Flex app?`,
        a: `The setup instructions will be shown by default every time you open the application. If you wish to hide these instructions toggle the “Show setup instruction” in the Settings menu.`
    },
    {
        q: `I am in the Settings tab, how do I get back to the main screen?`,
        a: `Click on the arrow situated in the top left-hand corner of the screen.`
    },
    {
        q: `Tuning appears on the main screen during active scanning`,
        a: `This is normal as the software is automatically recalibrating itself. No action is required as the indication will disappear, and it does not influence the scanning activity.`
    },
    {
        q: `A red cloud with a red “up” arrow displayed in the top icon bar`,
        a: `Your device is not connected to the internet, resolve your device connectivity.`
    },
    {
        q: `The location in the top icon bar is crossed out.`,
        a: `Ensure that your location permissions are set correctly. In the Device Settings menu: Settings/Security & Location/Location ensure that “Use Location” permission is set to “On”.`
    },
    {
        q: `Can I scan multiple subjects at the same time?`,
        a: `No, only one subject should be scanned at a time.`
    },
    {
        q: `Is the Flex scanning system portable?`,
        a: `No, the Flex camera should be mounted in a fixed permission and calibrated before use. The distance from the camera to the scanning subject should also remain constant. You can move the system, but it should be re-calibrated if any changes are made to the setup.`
    }
];

export const faqListDash: any[] = [
    {
        q: `I have lost or forgotten my password for the Dashboard`,
        a: `Use the “forgot password” function on the login screen to request a new password.`
    },
    {
        q: `I have accidentally deleted one of my devices from the Dashboard. `,
        a: `Use the “Manage Devices” function in the drop-down menu to manually reload the device. You will need to enter the device serial number and IMEI. To find these numbers enter *#06#* in the dialler on the Cat S61. You will also need to enter the SIM card ICCI and IMSI copied from the SIM card in the device.`
    },
    {
        q: `One of my Cat S61 cameras has been replaced, how do I replace it on the dashboard?`,
        a: `Use the “Manage Devices” function in the drop-down menu to identify the device that you are removing from the system. Edit this device and replace the serial number and IMEI number with those of the new device that you are replacing it with. Assuming the SIM remains the same leave this field unchanged.`
    },
    {
        q: `I have had to do a SIM swap, what must I do?`,
        a: `Use the “Manage Devices” function in the drop-down menu to identify the device subject to SIM swap on the system. Edit this device and replace the SIM ID number with that of the replaced SIM. Assuming the device remains the same leave the serial number and IMEI fields unchanged.`
    },
    {
        q: `I cannot access the “Manage Devices” function in the menu.`,
        a: `Check with the Dashboard owner in your organization to ensure you have sufficient privileges on the Dashboard. Only “Owners” and “Managers” can manage devices.`
    }
]